export default function initTouch(target = "u-touch") {

  const $target = $("." + target),
        duration = 350;

  $($target).each(function() {
    $(this).click(function(e) {

      let elem, d, x, y;

      if($(this).find("." + target + "__elem").length === 0)
      $(this).prepend("<div class='" + target + "__elem'></div>");

      elem = $(this).find("." + target + "__elem");
      elem.removeClass(target + "--animate");

      if(!elem.height() && !elem.width()){
        d = Math.max($(this).outerWidth(), $(this).outerHeight());
        elem.css({height: d, width: d});
      }

      x = e.pageX - $(this).offset().left - elem.width()/2;
      y = e.pageY - $(this).offset().top - elem.height()/2;

      elem.css({top: y + 'px', left: x + 'px'}).addClass(target + "--animate");

      window.setTimeout(function(){
        elem.removeClass(target + "--animate");
      }, duration);

    });
  });

}



// WEBPACK FOOTER //
// ./js/utils/Touch.js